import { j as x } from "./jsx-runtime-3tyXYecC.mjs";
import * as c from "react";
import { forwardRef as oo, useState as ft, useMemo as no, useEffect as ro, useCallback as ao } from "react";
import { c as ye } from "./index-DkZ16bcJ.mjs";
import { f as We } from "./index-LyFokDcn.mjs";
import { d as io } from "./index-DH8DM7A9.mjs";
import { w as Qt } from "./sizes-DktS74Qp.mjs";
import { m as lo, c as so } from "./mui-DV6TgX2g.mjs";
import { c as v, b as oe, m as Xt, u as po } from "./tss-DN0acMKN.mjs";
import { M as co, d as uo } from "./constants-CnFYFetN.mjs";
import { a as fo } from "./hooks-nrLF1Lxr.mjs";
import { u as wt, s as Ft, _ as Zt, a as bt } from "./objectWithoutPropertiesLoose-Cg0fb85x.mjs";
import { o as go } from "./ownerDocument-B2qVP_sX.mjs";
import * as mo from "react-dom";
import { P as At, c as bo } from "./Popper-X3MMNHL3.mjs";
import { I as jt } from "./icon-v2-DGtVEk7e.mjs";
import { g as Tt, c as de } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { i as ue } from "./outlined-input-wBBzs904.mjs";
import { g as _e } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { c as Mt } from "./createSvgIcon-ButWPptu.mjs";
import { m as Re } from "./memoTheme-BzXKG_-k.mjs";
import { u as Ot } from "./useSlot-CRj3SG25.mjs";
import { s as Z, u as Dt, c as Et } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { I as Jt } from "./IconButton-BIUHNiXo.mjs";
import { P as Yt } from "./Paper-J9MVFbwr.mjs";
import { u as ho } from "./useId-CK6Kn3Tn.mjs";
import { u as St } from "./useControlled-ZIJRsfP8.mjs";
import { u as gt } from "./useEventCallback-B4gn-DZo.mjs";
import { s as xo, u as yo } from "./useForkRef-C_4o__cU.mjs";
import { c as mt } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { B as Vt } from "./ButtonBase-BIvHZGlt.mjs";
import { a as Co } from "./X10x10-Bso1Otyr.mjs";
const Io = (e) => {
  const n = c.useRef({});
  return c.useEffect(() => {
    n.current = e;
  }), n.current;
}, $o = Mt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function Ht(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function vo(e = {}) {
  const {
    ignoreAccents: n = !0,
    ignoreCase: r = !0,
    limit: a,
    matchFrom: p = "any",
    stringify: u,
    trim: s = !1
  } = e;
  return (d, {
    inputValue: b,
    getOptionLabel: S
  }) => {
    let y = s ? b.trim() : b;
    r && (y = y.toLowerCase()), n && (y = Ht(y));
    const w = y ? d.filter((B) => {
      let A = (u || S)(B);
      return r && (A = A.toLowerCase()), n && (A = Ht(A)), p === "start" ? A.startsWith(y) : A.includes(y);
    }) : d;
    return typeof a == "number" ? w.slice(0, a) : w;
  };
}
const Po = vo(), Ut = 5, Oo = (e) => {
  var n;
  return e.current !== null && ((n = e.current.parentElement) == null ? void 0 : n.contains(document.activeElement));
}, So = [];
function ko(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: n = Oo,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: r = "Mui",
    autoComplete: a = !1,
    autoHighlight: p = !1,
    autoSelect: u = !1,
    blurOnSelect: s = !1,
    clearOnBlur: d = !e.freeSolo,
    clearOnEscape: b = !1,
    componentName: S = "useAutocomplete",
    defaultValue: y = e.multiple ? So : null,
    disableClearable: w = !1,
    disableCloseOnSelect: B = !1,
    disabled: A,
    disabledItemsFocusable: L = !1,
    disableListWrap: U = !1,
    filterOptions: G = Po,
    filterSelectedOptions: j = !1,
    freeSolo: F = !1,
    getOptionDisabled: D,
    getOptionKey: J,
    getOptionLabel: ae = (o) => o.label ?? o,
    groupBy: z,
    handleHomeEndKeys: se = !e.freeSolo,
    id: Y,
    includeInputInList: ne = !1,
    inputValue: re,
    isOptionEqualToValue: ee = (o, t) => o === t,
    multiple: P = !1,
    onChange: fe,
    onClose: q,
    onHighlightChange: Ce,
    onInputChange: te,
    onOpen: ge,
    open: Le,
    openOnFocus: T = !1,
    options: tt,
    readOnly: Ie = !1,
    selectOnFocus: $e = !e.freeSolo,
    value: Be
  } = e, K = ho(Y);
  let k = ae;
  k = (o) => {
    const t = ae(o);
    return typeof t != "string" ? String(t) : t;
  };
  const ve = c.useRef(!1), Ae = c.useRef(!0), E = c.useRef(null), W = c.useRef(null), [Pe, ot] = c.useState(null), [Q, Me] = c.useState(-1), Ge = p ? 0 : -1, V = c.useRef(Ge), [l, H] = St({
    controlled: Be,
    default: y,
    name: S
  }), [C, Oe] = St({
    controlled: re,
    default: "",
    name: S,
    state: "inputValue"
  }), [De, Ke] = c.useState(!1), Ee = c.useCallback((o, t, i) => {
    if (!(P ? l.length < t.length : t !== null) && !d)
      return;
    let m;
    if (P)
      m = "";
    else if (t == null)
      m = "";
    else {
      const M = k(t);
      m = typeof M == "string" ? M : "";
    }
    C !== m && (Oe(m), te && te(o, m, i));
  }, [k, C, P, te, Oe, d, l]), [Se, nt] = St({
    controlled: Le,
    default: !1,
    name: S,
    state: "open"
  }), [rt, xt] = c.useState(!0), Ne = !P && l != null && C === k(l), X = Se && !Ie, R = X ? G(
    tt.filter((o) => !(j && (P ? l : [l]).some((t) => t !== null && ee(o, t)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ne && rt ? "" : C,
      getOptionLabel: k
    }
  ) : [], pe = Io({
    filteredOptions: R,
    value: l,
    inputValue: C
  });
  c.useEffect(() => {
    const o = l !== pe.value;
    De && !o || F && !o || Ee(null, l, "reset");
  }, [l, Ee, De, pe.value, F]);
  const qe = Se && R.length > 0 && !Ie, ze = gt((o) => {
    o === -1 ? E.current.focus() : Pe.querySelector(`[data-tag-index="${o}"]`).focus();
  });
  c.useEffect(() => {
    P && Q > l.length - 1 && (Me(-1), ze(-1));
  }, [l, P, Q, ze]);
  function at(o, t) {
    if (!W.current || o < 0 || o >= R.length)
      return -1;
    let i = o;
    for (; ; ) {
      const f = W.current.querySelector(`[data-option-index="${i}"]`), m = L ? !1 : !f || f.disabled || f.getAttribute("aria-disabled") === "true";
      if (f && f.hasAttribute("tabindex") && !m)
        return i;
      if (t === "next" ? i = (i + 1) % R.length : i = (i - 1 + R.length) % R.length, i === o)
        return -1;
    }
  }
  const me = gt(({
    event: o,
    index: t,
    reason: i = "auto"
  }) => {
    if (V.current = t, t === -1 ? E.current.removeAttribute("aria-activedescendant") : E.current.setAttribute("aria-activedescendant", `${K}-option-${t}`), Ce && Ce(o, t === -1 ? null : R[t], i), !W.current)
      return;
    const f = W.current.querySelector(`[role="option"].${r}-focused`);
    f && (f.classList.remove(`${r}-focused`), f.classList.remove(`${r}-focusVisible`));
    let m = W.current;
    if (W.current.getAttribute("role") !== "listbox" && (m = W.current.parentElement.querySelector('[role="listbox"]')), !m)
      return;
    if (t === -1) {
      m.scrollTop = 0;
      return;
    }
    const M = W.current.querySelector(`[data-option-index="${t}"]`);
    if (M && (M.classList.add(`${r}-focused`), i === "keyboard" && M.classList.add(`${r}-focusVisible`), m.scrollHeight > m.clientHeight && i !== "mouse" && i !== "touch")) {
      const O = M, le = m.clientHeight + m.scrollTop, pt = O.offsetTop + O.offsetHeight;
      pt > le ? m.scrollTop = pt - m.clientHeight : O.offsetTop - O.offsetHeight * (z ? 1.3 : 0) < m.scrollTop && (m.scrollTop = O.offsetTop - O.offsetHeight * (z ? 1.3 : 0));
    }
  }), ie = gt(({
    event: o,
    diff: t,
    direction: i = "next",
    reason: f = "auto"
  }) => {
    if (!X)
      return;
    const M = at((() => {
      const O = R.length - 1;
      if (t === "reset")
        return Ge;
      if (t === "start")
        return 0;
      if (t === "end")
        return O;
      const le = V.current + t;
      return le < 0 ? le === -1 && ne ? -1 : U && V.current !== -1 || Math.abs(t) > 1 ? 0 : O : le > O ? le === O + 1 && ne ? -1 : U || Math.abs(t) > 1 ? O : 0 : le;
    })(), i);
    if (me({
      index: M,
      reason: f,
      event: o
    }), a && t !== "reset")
      if (M === -1)
        E.current.value = C;
      else {
        const O = k(R[M]);
        E.current.value = O, O.toLowerCase().indexOf(C.toLowerCase()) === 0 && C.length > 0 && E.current.setSelectionRange(C.length, O.length);
      }
  }), yt = () => {
    const o = (t, i) => {
      const f = t ? k(t) : "", m = i ? k(i) : "";
      return f === m;
    };
    if (V.current !== -1 && pe.filteredOptions && pe.filteredOptions.length !== R.length && pe.inputValue === C && (P ? l.length === pe.value.length && pe.value.every((t, i) => k(l[i]) === k(t)) : o(pe.value, l))) {
      const t = pe.filteredOptions[V.current];
      if (t)
        return R.findIndex((i) => k(i) === k(t));
    }
    return -1;
  }, Qe = c.useCallback(() => {
    if (!X)
      return;
    const o = yt();
    if (o !== -1) {
      V.current = o;
      return;
    }
    const t = P ? l[0] : l;
    if (R.length === 0 || t == null) {
      ie({
        diff: "reset"
      });
      return;
    }
    if (W.current) {
      if (t != null) {
        const i = R[V.current];
        if (P && i && l.findIndex((m) => ee(i, m)) !== -1)
          return;
        const f = R.findIndex((m) => ee(m, t));
        f === -1 ? ie({
          diff: "reset"
        }) : me({
          index: f
        });
        return;
      }
      if (V.current >= R.length - 1) {
        me({
          index: R.length - 1
        });
        return;
      }
      me({
        index: V.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    R.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    P ? !1 : l,
    j,
    ie,
    me,
    X,
    C,
    P
  ]), Ct = gt((o) => {
    xo(W, o), o && Qe();
  });
  c.useEffect(() => {
    Qe();
  }, [Qe]);
  const be = (o) => {
    Se || (nt(!0), xt(!0), ge && ge(o));
  }, he = (o, t) => {
    Se && (nt(!1), q && q(o, t));
  }, ke = (o, t, i, f) => {
    if (P) {
      if (l.length === t.length && l.every((m, M) => m === t[M]))
        return;
    } else if (l === t)
      return;
    fe && fe(o, t, i, f), H(t);
  }, Fe = c.useRef(!1), Te = (o, t, i = "selectOption", f = "options") => {
    let m = i, M = t;
    if (P) {
      M = Array.isArray(l) ? l.slice() : [];
      const O = M.findIndex((le) => ee(t, le));
      O === -1 ? M.push(t) : f !== "freeSolo" && (M.splice(O, 1), m = "removeOption");
    }
    Ee(o, M, m), ke(o, M, m, {
      option: t
    }), !B && (!o || !o.ctrlKey && !o.metaKey) && he(o, m), (s === !0 || s === "touch" && Fe.current || s === "mouse" && !Fe.current) && E.current.blur();
  };
  function je(o, t) {
    if (o === -1)
      return -1;
    let i = o;
    for (; ; ) {
      if (t === "next" && i === l.length || t === "previous" && i === -1)
        return -1;
      const f = Pe.querySelector(`[data-tag-index="${i}"]`);
      if (!f || !f.hasAttribute("tabindex") || f.disabled || f.getAttribute("aria-disabled") === "true")
        i += t === "next" ? 1 : -1;
      else
        return i;
    }
  }
  const Xe = (o, t) => {
    if (!P)
      return;
    C === "" && he(o, "toggleInput");
    let i = Q;
    Q === -1 ? C === "" && t === "previous" && (i = l.length - 1) : (i += t === "next" ? 1 : -1, i < 0 && (i = 0), i === l.length && (i = -1)), i = je(i, t), Me(i), ze(i);
  }, it = (o) => {
    ve.current = !0, Oe(""), te && te(o, "", "clear"), ke(o, P ? [] : null, "clear");
  }, Ve = (o) => (t) => {
    if (o.onKeyDown && o.onKeyDown(t), !t.defaultMuiPrevented && (Q !== -1 && !["ArrowLeft", "ArrowRight"].includes(t.key) && (Me(-1), ze(-1)), t.which !== 229))
      switch (t.key) {
        case "Home":
          X && se && (t.preventDefault(), ie({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: t
          }));
          break;
        case "End":
          X && se && (t.preventDefault(), ie({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: t
          }));
          break;
        case "PageUp":
          t.preventDefault(), ie({
            diff: -Ut,
            direction: "previous",
            reason: "keyboard",
            event: t
          }), be(t);
          break;
        case "PageDown":
          t.preventDefault(), ie({
            diff: Ut,
            direction: "next",
            reason: "keyboard",
            event: t
          }), be(t);
          break;
        case "ArrowDown":
          t.preventDefault(), ie({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: t
          }), be(t);
          break;
        case "ArrowUp":
          t.preventDefault(), ie({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: t
          }), be(t);
          break;
        case "ArrowLeft":
          Xe(t, "previous");
          break;
        case "ArrowRight":
          Xe(t, "next");
          break;
        case "Enter":
          if (V.current !== -1 && X) {
            const i = R[V.current], f = D ? D(i) : !1;
            if (t.preventDefault(), f)
              return;
            Te(t, i, "selectOption"), a && E.current.setSelectionRange(E.current.value.length, E.current.value.length);
          } else F && C !== "" && Ne === !1 && (P && t.preventDefault(), Te(t, C, "createOption", "freeSolo"));
          break;
        case "Escape":
          X ? (t.preventDefault(), t.stopPropagation(), he(t, "escape")) : b && (C !== "" || P && l.length > 0) && (t.preventDefault(), t.stopPropagation(), it(t));
          break;
        case "Backspace":
          if (P && !Ie && C === "" && l.length > 0) {
            const i = Q === -1 ? l.length - 1 : Q, f = l.slice();
            f.splice(i, 1), ke(t, f, "removeOption", {
              option: l[i]
            });
          }
          break;
        case "Delete":
          if (P && !Ie && C === "" && l.length > 0 && Q !== -1) {
            const i = Q, f = l.slice();
            f.splice(i, 1), ke(t, f, "removeOption", {
              option: l[i]
            });
          }
          break;
      }
  }, It = (o) => {
    Ke(!0), T && !ve.current && be(o);
  }, lt = (o) => {
    if (n(W)) {
      E.current.focus();
      return;
    }
    Ke(!1), Ae.current = !0, ve.current = !1, u && V.current !== -1 && X ? Te(o, R[V.current], "blur") : u && F && C !== "" ? Te(o, C, "blur", "freeSolo") : d && Ee(o, l, "blur"), he(o, "blur");
  }, He = (o) => {
    const t = o.target.value;
    C !== t && (Oe(t), xt(!1), te && te(o, t, "input")), t === "" ? !w && !P && ke(o, null, "clear") : be(o);
  }, Ze = (o) => {
    const t = Number(o.currentTarget.getAttribute("data-option-index"));
    V.current !== t && me({
      event: o,
      index: t,
      reason: "mouse"
    });
  }, Je = (o) => {
    me({
      event: o,
      index: Number(o.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Fe.current = !0;
  }, $t = (o) => {
    const t = Number(o.currentTarget.getAttribute("data-option-index"));
    Te(o, R[t], "selectOption"), Fe.current = !1;
  }, vt = (o) => (t) => {
    const i = l.slice();
    i.splice(o, 1), ke(t, i, "removeOption", {
      option: l[o]
    });
  }, st = (o) => {
    Se ? he(o, "toggleInput") : be(o);
  }, Nt = (o) => {
    o.currentTarget.contains(o.target) && o.target.getAttribute("id") !== K && o.preventDefault();
  }, Ye = (o) => {
    o.currentTarget.contains(o.target) && (E.current.focus(), $e && Ae.current && E.current.selectionEnd - E.current.selectionStart === 0 && E.current.select(), Ae.current = !1);
  }, _ = (o) => {
    !A && (C === "" || !Se) && st(o);
  };
  let N = F && C.length > 0;
  N = N || (P ? l.length > 0 : l !== null);
  let xe = R;
  return z && (xe = R.reduce((o, t, i) => {
    const f = z(t);
    return o.length > 0 && o[o.length - 1].group === f ? o[o.length - 1].options.push(t) : o.push({
      key: i,
      index: i,
      group: f,
      options: [t]
    }), o;
  }, [])), A && De && lt(), {
    getRootProps: (o = {}) => ({
      "aria-owns": qe ? `${K}-listbox` : null,
      ...o,
      onKeyDown: Ve(o),
      onMouseDown: Nt,
      onClick: Ye
    }),
    getInputLabelProps: () => ({
      id: `${K}-label`,
      htmlFor: K
    }),
    getInputProps: () => ({
      id: K,
      value: C,
      onBlur: lt,
      onFocus: It,
      onChange: He,
      onMouseDown: _,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": X ? "" : null,
      "aria-autocomplete": a ? "both" : "list",
      "aria-controls": qe ? `${K}-listbox` : void 0,
      "aria-expanded": qe,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: E,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: A
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: it
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: st
    }),
    getTagProps: ({
      index: o
    }) => ({
      key: o,
      "data-tag-index": o,
      tabIndex: -1,
      ...!Ie && {
        onDelete: vt(o)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${K}-listbox`,
      "aria-labelledby": `${K}-label`,
      ref: Ct,
      onMouseDown: (o) => {
        o.preventDefault();
      }
    }),
    getOptionProps: ({
      index: o,
      option: t
    }) => {
      const i = (P ? l : [l]).some((m) => m != null && ee(t, m)), f = D ? D(t) : !1;
      return {
        key: (J == null ? void 0 : J(t)) ?? k(t),
        tabIndex: -1,
        role: "option",
        id: `${K}-option-${o}`,
        onMouseMove: Ze,
        onClick: $t,
        onTouchStart: Je,
        "data-option-index": o,
        "aria-disabled": f,
        "aria-selected": i
      };
    },
    id: K,
    inputValue: C,
    value: l,
    dirty: N,
    expanded: X && Pe,
    popupOpen: X,
    focused: De || Q !== -1,
    anchorEl: Pe,
    setAnchorEl: ot,
    focusedTag: Q,
    groupedOptions: xe
  };
}
function wo(e) {
  return Tt("MuiListSubheader", e);
}
_e("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const Ro = (e) => {
  const {
    classes: n,
    color: r,
    disableGutters: a,
    inset: p,
    disableSticky: u
  } = e, s = {
    root: ["root", r !== "default" && `color${v(r)}`, !a && "gutters", p && "inset", !u && "sticky"]
  };
  return Et(s, wo, n);
}, Lo = Z("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e;
    return [n.root, r.color !== "default" && n[`color${v(r.color)}`], !r.disableGutters && n.gutters, r.inset && n.inset, !r.disableSticky && n.sticky];
  }
})(Re(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: n
    }) => !n.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: n
    }) => n.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: n
    }) => !n.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Rt = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const a = Dt({
    props: n,
    name: "MuiListSubheader"
  }), {
    className: p,
    color: u = "default",
    component: s = "li",
    disableGutters: d = !1,
    disableSticky: b = !1,
    inset: S = !1,
    ...y
  } = a, w = {
    ...a,
    color: u,
    component: s,
    disableGutters: d,
    disableSticky: b,
    inset: S
  }, B = Ro(w);
  return /* @__PURE__ */ x.jsx(Lo, {
    as: s,
    className: de(B.root, p),
    ref: r,
    ownerState: w,
    ...y
  });
});
Rt && (Rt.muiSkipListHighlight = !0);
const Ao = Mt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function To(e) {
  return Tt("MuiChip", e);
}
const h = _e("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), Mo = (e) => {
  const {
    classes: n,
    disabled: r,
    size: a,
    color: p,
    iconColor: u,
    onDelete: s,
    clickable: d,
    variant: b
  } = e, S = {
    root: ["root", b, r && "disabled", `size${v(a)}`, `color${v(p)}`, d && "clickable", d && `clickableColor${v(p)}`, s && "deletable", s && `deletableColor${v(p)}`, `${b}${v(p)}`],
    label: ["label", `label${v(a)}`],
    avatar: ["avatar", `avatar${v(a)}`, `avatarColor${v(p)}`],
    icon: ["icon", `icon${v(a)}`, `iconColor${v(u)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${v(a)}`, `deleteIconColor${v(p)}`, `deleteIcon${v(b)}Color${v(p)}`]
  };
  return Et(S, To, n);
}, Do = Z("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e, {
      color: a,
      iconColor: p,
      clickable: u,
      onDelete: s,
      size: d,
      variant: b
    } = r;
    return [{
      [`& .${h.avatar}`]: n.avatar
    }, {
      [`& .${h.avatar}`]: n[`avatar${v(d)}`]
    }, {
      [`& .${h.avatar}`]: n[`avatarColor${v(a)}`]
    }, {
      [`& .${h.icon}`]: n.icon
    }, {
      [`& .${h.icon}`]: n[`icon${v(d)}`]
    }, {
      [`& .${h.icon}`]: n[`iconColor${v(p)}`]
    }, {
      [`& .${h.deleteIcon}`]: n.deleteIcon
    }, {
      [`& .${h.deleteIcon}`]: n[`deleteIcon${v(d)}`]
    }, {
      [`& .${h.deleteIcon}`]: n[`deleteIconColor${v(a)}`]
    }, {
      [`& .${h.deleteIcon}`]: n[`deleteIcon${v(b)}Color${v(a)}`]
    }, n.root, n[`size${v(d)}`], n[`color${v(a)}`], u && n.clickable, u && a !== "default" && n[`clickableColor${v(a)})`], s && n.deletable, s && a !== "default" && n[`deletableColor${v(a)}`], n[b], n[`${b}${v(a)}`]];
  }
})(Re(({
  theme: e
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${h.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${h.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${h.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${h.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${h.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${h.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${h.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : oe(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : oe(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${h.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${h.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(mt(["contrastText"])).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        backgroundColor: (e.vars || e).palette[r].main,
        color: (e.vars || e).palette[r].contrastText,
        [`& .${h.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].contrastTextChannel} / 0.7)` : oe(e.palette[r].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].contrastText
          }
        }
      }
    })), {
      props: (r) => r.iconColor === r.color,
      style: {
        [`& .${h.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
        }
      }
    }, {
      props: (r) => r.iconColor === r.color && r.color !== "default",
      style: {
        [`& .${h.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${h.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : oe(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(mt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        onDelete: !0
      },
      style: {
        [`&.${h.focusVisible}`]: {
          background: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : oe(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${h.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : oe(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(mt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        clickable: !0
      },
      style: {
        [`&:hover, &.${h.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${h.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${h.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${h.avatar}`]: {
          marginLeft: 4
        },
        [`& .${h.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${h.icon}`]: {
          marginLeft: 4
        },
        [`& .${h.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${h.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${h.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(mt()).map(([r]) => ({
      props: {
        variant: "outlined",
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : oe(e.palette[r].main, 0.7)}`,
        [`&.${h.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : oe(e.palette[r].main, e.palette.action.hoverOpacity)
        },
        [`&.${h.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.focusOpacity})` : oe(e.palette[r].main, e.palette.action.focusOpacity)
        },
        [`& .${h.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : oe(e.palette[r].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].main
          }
        }
      }
    }))]
  };
})), Eo = Z("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e, {
      size: a
    } = r;
    return [n.label, n[`label${v(a)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function Wt(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const No = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const a = Dt({
    props: n,
    name: "MuiChip"
  }), {
    avatar: p,
    className: u,
    clickable: s,
    color: d = "default",
    component: b,
    deleteIcon: S,
    disabled: y = !1,
    icon: w,
    label: B,
    onClick: A,
    onDelete: L,
    onKeyDown: U,
    onKeyUp: G,
    size: j = "medium",
    variant: F = "filled",
    tabIndex: D,
    skipFocusWhenDisabled: J = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...ae
  } = a, z = c.useRef(null), se = yo(z, r), Y = (T) => {
    T.stopPropagation(), L && L(T);
  }, ne = (T) => {
    T.currentTarget === T.target && Wt(T) && T.preventDefault(), U && U(T);
  }, re = (T) => {
    T.currentTarget === T.target && L && Wt(T) && L(T), G && G(T);
  }, ee = s !== !1 && A ? !0 : s, P = ee || L ? Vt : b || "div", fe = {
    ...a,
    component: P,
    disabled: y,
    size: j,
    color: d,
    iconColor: /* @__PURE__ */ c.isValidElement(w) && w.props.color || d,
    onDelete: !!L,
    clickable: ee,
    variant: F
  }, q = Mo(fe), Ce = P === Vt ? {
    component: b || "div",
    focusVisibleClassName: q.focusVisible,
    ...L && {
      disableRipple: !0
    }
  } : {};
  let te = null;
  L && (te = S && /* @__PURE__ */ c.isValidElement(S) ? /* @__PURE__ */ c.cloneElement(S, {
    className: de(S.props.className, q.deleteIcon),
    onClick: Y
  }) : /* @__PURE__ */ x.jsx(Ao, {
    className: de(q.deleteIcon),
    onClick: Y
  }));
  let ge = null;
  p && /* @__PURE__ */ c.isValidElement(p) && (ge = /* @__PURE__ */ c.cloneElement(p, {
    className: de(q.avatar, p.props.className)
  }));
  let Le = null;
  return w && /* @__PURE__ */ c.isValidElement(w) && (Le = /* @__PURE__ */ c.cloneElement(w, {
    className: de(q.icon, w.props.className)
  })), /* @__PURE__ */ x.jsxs(Do, {
    as: P,
    className: de(q.root, u),
    disabled: ee && y ? !0 : void 0,
    onClick: A,
    onKeyDown: ne,
    onKeyUp: re,
    ref: se,
    tabIndex: J && y ? -1 : D,
    ownerState: fe,
    ...Ce,
    ...ae,
    children: [ge || Le, /* @__PURE__ */ x.jsx(Eo, {
      className: de(q.label),
      ownerState: fe,
      children: B
    }), te]
  });
}), kt = {
  ...ue,
  ..._e("MuiInput", ["root", "underline", "input"])
}, _t = {
  ...ue,
  ..._e("MuiOutlinedInput", ["root", "notchedOutline", "input"])
}, Ue = {
  ...ue,
  ..._e("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, zo = Mt(/* @__PURE__ */ x.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function Fo(e) {
  return Tt("MuiAutocomplete", e);
}
const g = _e("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var Bt, Gt;
const jo = (e) => {
  const {
    classes: n,
    disablePortal: r,
    expanded: a,
    focused: p,
    fullWidth: u,
    hasClearIcon: s,
    hasPopupIcon: d,
    inputFocused: b,
    popupOpen: S,
    size: y
  } = e, w = {
    root: ["root", a && "expanded", p && "focused", u && "fullWidth", s && "hasClearIcon", d && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", b && "inputFocused"],
    tag: ["tag", `tagSize${v(y)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", S && "popupIndicatorOpen"],
    popper: ["popper", r && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Et(w, Fo, n);
}, Vo = Z("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e, {
      fullWidth: a,
      hasClearIcon: p,
      hasPopupIcon: u,
      inputFocused: s,
      size: d
    } = r;
    return [{
      [`& .${g.tag}`]: n.tag
    }, {
      [`& .${g.tag}`]: n[`tagSize${v(d)}`]
    }, {
      [`& .${g.inputRoot}`]: n.inputRoot
    }, {
      [`& .${g.input}`]: n.input
    }, {
      [`& .${g.input}`]: s && n.inputFocused
    }, n.root, a && n.fullWidth, u && n.hasPopupIcon, p && n.hasClearIcon];
  }
})({
  [`&.${g.focused} .${g.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${g.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${g.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${g.inputRoot}`]: {
    [`.${g.hasPopupIcon}&, .${g.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${g.hasPopupIcon}.${g.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${g.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${kt.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${kt.root}.${ue.sizeSmall}`]: {
    [`& .${kt.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${_t.root}`]: {
    padding: 9,
    [`.${g.hasPopupIcon}&, .${g.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${g.hasPopupIcon}.${g.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${g.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${g.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${_t.root}.${ue.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${g.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Ue.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${g.hasPopupIcon}&, .${g.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${g.hasPopupIcon}.${g.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Ue.input}`]: {
      padding: "7px 4px"
    },
    [`& .${g.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ue.root}.${ue.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Ue.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${ue.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Ue.root}.${ue.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${g.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Ue.root}.${ue.hiddenLabel}.${ue.sizeSmall}`]: {
    [`& .${g.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${g.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${g.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${g.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${g.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), Ho = Z("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, n) => n.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), Uo = Z(Jt, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, n) => n.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), Wo = Z(Jt, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, n) => ({
    ...n.popupIndicator,
    ...e.popupOpen && n.popupIndicatorOpen
  })
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), _o = Z(At, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${g.option}`]: n.option
    }, n.popper, r.disablePortal && n.popperDisablePortal];
  }
})(Re(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), Bo = Z(Yt, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, n) => n.paper
})(Re(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), Go = Z("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, n) => n.loading
})(Re(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Ko = Z("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, n) => n.noOptions
})(Re(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), qo = Z("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, n) => n.listbox
})(Re(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${g.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${g.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${g.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : oe(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${g.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : oe(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${g.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : oe(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), Qo = Z(Rt, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, n) => n.groupLabel
})(Re(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Xo = Z("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, n) => n.groupUl
})({
  padding: 0,
  [`& .${g.option}`]: {
    paddingLeft: 24
  }
}), Zo = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const a = Dt({
    props: n,
    name: "MuiAutocomplete"
  }), {
    autoComplete: p = !1,
    autoHighlight: u = !1,
    autoSelect: s = !1,
    blurOnSelect: d = !1,
    ChipProps: b,
    className: S,
    clearIcon: y = Bt || (Bt = /* @__PURE__ */ x.jsx($o, {
      fontSize: "small"
    })),
    clearOnBlur: w = !a.freeSolo,
    clearOnEscape: B = !1,
    clearText: A = "Clear",
    closeText: L = "Close",
    componentsProps: U,
    defaultValue: G = a.multiple ? [] : null,
    disableClearable: j = !1,
    disableCloseOnSelect: F = !1,
    disabled: D = !1,
    disabledItemsFocusable: J = !1,
    disableListWrap: ae = !1,
    disablePortal: z = !1,
    filterOptions: se,
    filterSelectedOptions: Y = !1,
    forcePopupIcon: ne = "auto",
    freeSolo: re = !1,
    fullWidth: ee = !1,
    getLimitTagsText: P = (I) => `+${I}`,
    getOptionDisabled: fe,
    getOptionKey: q,
    getOptionLabel: Ce,
    isOptionEqualToValue: te,
    groupBy: ge,
    handleHomeEndKeys: Le = !a.freeSolo,
    id: T,
    includeInputInList: tt = !1,
    inputValue: Ie,
    limitTags: $e = -1,
    ListboxComponent: Be,
    ListboxProps: K,
    loading: k = !1,
    loadingText: ve = "Loading…",
    multiple: Ae = !1,
    noOptionsText: E = "No options",
    onChange: W,
    onClose: Pe,
    onHighlightChange: ot,
    onInputChange: Q,
    onOpen: Me,
    open: Ge,
    openOnFocus: V = !1,
    openText: l = "Open",
    options: H,
    PaperComponent: C,
    PopperComponent: Oe,
    popupIcon: De = Gt || (Gt = /* @__PURE__ */ x.jsx(zo, {})),
    readOnly: Ke = !1,
    renderGroup: Ee,
    renderInput: Se,
    renderOption: nt,
    renderTags: rt,
    selectOnFocus: xt = !a.freeSolo,
    size: Ne = "medium",
    slots: X = {},
    slotProps: R = {},
    value: pe,
    ...qe
  } = a, {
    getRootProps: ze,
    getInputProps: at,
    getInputLabelProps: me,
    getPopupIndicatorProps: ie,
    getClearProps: yt,
    getTagProps: Qe,
    getListboxProps: Ct,
    getOptionProps: be,
    value: he,
    dirty: ke,
    expanded: Fe,
    id: Te,
    popupOpen: je,
    focused: Xe,
    focusedTag: it,
    anchorEl: Ve,
    setAnchorEl: It,
    inputValue: lt,
    groupedOptions: He
  } = ko({
    ...a,
    componentName: "Autocomplete"
  }), Ze = !j && !D && ke && !Ke, Je = (!re || ne === !0) && ne !== !1, {
    onMouseDown: $t
  } = at(), {
    ref: vt,
    ...st
  } = Ct(), Ye = Ce || ((I) => I.label ?? I), _ = {
    ...a,
    disablePortal: z,
    expanded: Fe,
    focused: Xe,
    fullWidth: ee,
    getOptionLabel: Ye,
    hasClearIcon: Ze,
    hasPopupIcon: Je,
    inputFocused: it === -1,
    popupOpen: je,
    size: Ne
  }, N = jo(_), xe = {
    slots: {
      paper: C,
      popper: Oe,
      ...X
    },
    slotProps: {
      chip: b,
      listbox: K,
      ...U,
      ...R
    }
  }, [o, t] = Ot("listbox", {
    elementType: qo,
    externalForwardedProps: xe,
    ownerState: _,
    className: N.listbox,
    additionalProps: st,
    ref: vt
  }), [i, f] = Ot("paper", {
    elementType: Yt,
    externalForwardedProps: xe,
    ownerState: _,
    className: N.paper
  }), [m, M] = Ot("popper", {
    elementType: At,
    externalForwardedProps: xe,
    ownerState: _,
    className: N.popper,
    additionalProps: {
      disablePortal: z,
      style: {
        width: Ve ? Ve.clientWidth : null
      },
      role: "presentation",
      anchorEl: Ve,
      open: je
    }
  });
  let O;
  if (Ae && he.length > 0) {
    const I = (ce) => ({
      className: N.tag,
      disabled: D,
      ...Qe(ce)
    });
    rt ? O = rt(he, I, _) : O = he.map((ce, we) => {
      const {
        key: et,
        ...to
      } = I({
        index: we
      });
      return /* @__PURE__ */ x.jsx(No, {
        label: Ye(ce),
        size: Ne,
        ...to,
        ...xe.slotProps.chip
      }, et);
    });
  }
  if ($e > -1 && Array.isArray(O)) {
    const I = O.length - $e;
    !Xe && I > 0 && (O = O.splice(0, $e), O.push(/* @__PURE__ */ x.jsx("span", {
      className: N.tag,
      children: P(I)
    }, O.length)));
  }
  const pt = Ee || ((I) => /* @__PURE__ */ x.jsxs("li", {
    children: [/* @__PURE__ */ x.jsx(Qo, {
      className: N.groupLabel,
      ownerState: _,
      component: "div",
      children: I.group
    }), /* @__PURE__ */ x.jsx(Xo, {
      className: N.groupUl,
      ownerState: _,
      children: I.children
    })]
  }, I.key)), eo = nt || ((I, ce) => {
    const {
      key: we,
      ...et
    } = I;
    return /* @__PURE__ */ x.jsx("li", {
      ...et,
      children: Ye(ce)
    }, we);
  }), zt = (I, ce) => {
    const we = be({
      option: I,
      index: ce
    });
    return eo({
      ...we,
      className: N.option
    }, I, {
      selected: we["aria-selected"],
      index: ce,
      inputValue: lt
    }, _);
  }, ct = xe.slotProps.clearIndicator, ut = xe.slotProps.popupIndicator, Pt = (I) => /* @__PURE__ */ x.jsx(_o, {
    as: m,
    ...M,
    children: /* @__PURE__ */ x.jsx(Bo, {
      as: i,
      ...f,
      children: I
    })
  });
  let dt = null;
  return He.length > 0 ? dt = Pt(
    // TODO v7: remove `as` prop and move ListboxComponentProp to externalForwardedProps or remove ListboxComponentProp entirely
    // https://github.com/mui/material-ui/pull/43994#issuecomment-2401945800
    /* @__PURE__ */ x.jsx(o, {
      as: Be,
      ...t,
      children: He.map((I, ce) => ge ? pt({
        key: I.key,
        group: I.group,
        children: I.options.map((we, et) => zt(we, I.index + et))
      }) : zt(I, ce))
    })
  ) : k && He.length === 0 ? dt = Pt(/* @__PURE__ */ x.jsx(Go, {
    className: N.loading,
    ownerState: _,
    children: ve
  })) : He.length === 0 && !re && !k && (dt = Pt(/* @__PURE__ */ x.jsx(Ko, {
    className: N.noOptions,
    ownerState: _,
    role: "presentation",
    onMouseDown: (I) => {
      I.preventDefault();
    },
    children: E
  }))), /* @__PURE__ */ x.jsxs(c.Fragment, {
    children: [/* @__PURE__ */ x.jsx(Vo, {
      ref: r,
      className: de(N.root, S),
      ownerState: _,
      ...ze(qe),
      children: Se({
        id: Te,
        disabled: D,
        fullWidth: !0,
        size: Ne === "small" ? "small" : void 0,
        InputLabelProps: me(),
        InputProps: {
          ref: It,
          className: N.inputRoot,
          startAdornment: O,
          onMouseDown: (I) => {
            I.target === I.currentTarget && $t(I);
          },
          ...(Ze || Je) && {
            endAdornment: /* @__PURE__ */ x.jsxs(Ho, {
              className: N.endAdornment,
              ownerState: _,
              children: [Ze ? /* @__PURE__ */ x.jsx(Uo, {
                ...yt(),
                "aria-label": A,
                title: A,
                ownerState: _,
                ...ct,
                className: de(N.clearIndicator, ct == null ? void 0 : ct.className),
                children: y
              }) : null, Je ? /* @__PURE__ */ x.jsx(Wo, {
                ...ie(),
                disabled: D,
                "aria-label": je ? L : l,
                title: je ? L : l,
                ownerState: _,
                ...ut,
                className: de(N.popupIndicator, ut == null ? void 0 : ut.className),
                children: De
              }) : null]
            })
          }
        },
        inputProps: {
          className: N.input,
          disabled: D,
          readOnly: Ke,
          ...at()
        }
      })
    }), Ve ? dt : null]
  });
}), Wn = window.jQuery ? $.__("Clear") : "Clear", _n = window.jQuery ? $.__("Close") : "Close", Bn = window.jQuery ? $.__("Loading...") : "Loading...", Gn = window.jQuery ? $.__("Open") : "Open";
function Kn(e) {
  return `+${e} ${window.jQuery ? $.__("More") : "More"}`;
}
function Jo() {
  return io.getMaxZIndex() + 10;
}
const Yo = Xt()((e, n) => {
  const { constructs: r, spacing: a } = e, { hasClearButton: p, hasPopupToggle: u, variant: s } = n, d = u ? parseInt(a(s === "form" ? 4 : 5), 10) : 0, b = p ? parseInt(a(5), 10) : 0, S = Math.max(
    d + b + (p ? 0 : parseInt(a(1.5), 10)),
    parseInt(a(2), 10)
  );
  return {
    root: {
      "& .MuiInputBase-root": {
        paddingLeft: a(s === "single" ? 2 : 1.5),
        paddingRight: S
      },
      "& .MuiAutocomplete-input": {
        paddingLeft: 0,
        paddingRight: 0
      },
      "& .MuiAutocomplete-endAdornment": {
        display: "flex",
        height: "100%",
        right: 0
      },
      "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator": {
        background: "unset",
        borderRadius: "unset",
        display: "grid",
        fill: r.icon.neutral.medium,
        margin: 0,
        placeContent: "center",
        transitionDuration: "0.2s",
        transitionProperty: "background, fill",
        "&:hover": {
          fill: r.icon.neutral.strong
        }
      },
      "& .MuiAutocomplete-clearIndicator": {
        padding: 0,
        width: b
      },
      "& .MuiAutocomplete-popupIndicator": {
        padding: 0,
        paddingRight: a(0.5),
        width: d,
        "&:before": {
          backgroundColor: r.border.neutral.weak,
          content: '""',
          height: `calc(100% - ${a(2)} - 2px)`,
          // -2px to account for border
          position: "absolute",
          width: 1
        }
      },
      // when open, prevent MUI flip of button and flip the icon instead
      "& .MuiAutocomplete-popupIndicatorOpen": {
        transform: "none",
        "& svg": {
          transform: "rotate(180deg)"
        }
      }
    }
  };
}), en = lo((e) => {
  const { mixins: n, palette: r, typography: a, mode: p } = e;
  return so({
    defaultPopupIcon: {
      alignItems: "center",
      display: "flex",
      fill: r.grey[700],
      justifyContent: "center"
    },
    inputRoot: {
      backgroundColor: r.background.default
    },
    listbox: {
      padding: "4px 0",
      "& .MuiAutocomplete-option": {
        minHeight: ({ hasRenderOption: u }) => u ? 0 : 32,
        // Override MUI specificity
        "&.Mui-focused.Mui-focused": {
          backgroundColor: r.primary.main,
          color: r.primary.contrastText
        },
        '&[aria-selected="true"]:not(.Mui-focused)': {
          backgroundColor: "inherit",
          color: "inherit"
        }
      }
    },
    groupLabel: {
      backgroundColor: "inherit",
      color: r.gray[700],
      fontSize: a.fabricFontSize("teenie"),
      lineHeight: a.fabricLineHeight("medium"),
      padding: "0 10px"
    },
    groupUl: {
      "& .MuiAutocomplete-option": {
        padding: ({ hasRenderOption: u }) => u ? 0 : "0 10px"
      }
    },
    option: {},
    paper: {
      margin: "4px 0 4px 0",
      "&:not(:empty)": {
        backgroundColor: r.common.white,
        border: `1px solid ${r.primary.main}`,
        borderRadius: 2,
        boxShadow: `0 0 0 2px ${n.alpha(r.primary.lighter, 0.35)}`
      }
    },
    popper: ({ popperZIndex: u, popupMinWidthFactor: s }) => ({
      minWidth: s !== 100 ? Qt[String(s)] : void 0,
      zIndex: u
    }),
    root: {
      outline: p === co.Dye ? `1px solid ${uo.main}` : void 0,
      "& .MuiIconButton-root": {
        height: 32,
        backgroundColor: r.grey[100],
        color: r.grey[700],
        marginRight: 0,
        width: 25,
        "&.Mui-disabled": {
          color: r.grey[400]
        }
      },
      "& .MuiAutocomplete-input": {
        minWidth: 30,
        width: 0
      },
      "& .MuiAutocomplete-inputRoot": {
        "&.Mui-disabled": {
          "& .MuiAutocomplete-tag:not(.MuiChip-root)": {
            color: r.gray[500]
          }
        },
        "& .MuiAutocomplete-tag:not(.MuiChip-root)": {
          color: r.gray[700]
        }
      },
      "& .MuiAutocomplete-clearIndicator": {
        backgroundColor: "transparent",
        padding: 10
      }
    }
  });
}), ht = typeof window < "u" ? c.useLayoutEffect : c.useEffect;
function tn(e) {
  return typeof e == "function" ? e() : e;
}
const on = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const {
    children: a,
    container: p,
    disablePortal: u = !1
  } = n, [s, d] = c.useState(null), b = wt(/* @__PURE__ */ c.isValidElement(a) ? a.ref : null, r);
  return ht(() => {
    u || d(tn(p) || document.body);
  }, [p, u]), ht(() => {
    if (s && !u)
      return Ft(r, s), () => {
        Ft(r, null);
      };
  }, [r, s, u]), u ? /* @__PURE__ */ c.isValidElement(a) ? /* @__PURE__ */ c.cloneElement(a, {
    ref: b
  }) : a : s && /* @__PURE__ */ mo.createPortal(a, s);
}), nn = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "ownerState", "placement", "popperOptions", "popperRef", "TransitionProps"], rn = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"];
function an(e, n) {
  if (n === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Lt(e) {
  return typeof e == "function" ? e() : e;
}
const ln = {}, sn = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const {
    anchorEl: a,
    children: p,
    direction: u,
    disablePortal: s,
    modifiers: d,
    open: b,
    placement: S,
    popperOptions: y,
    popperRef: w,
    TransitionProps: B
  } = n, A = Zt(n, nn), L = c.useRef(null), U = wt(L, r), G = c.useRef(null), j = wt(G, w), F = c.useRef(j);
  ht(() => {
    F.current = j;
  }, [j]), c.useImperativeHandle(w, () => G.current, []);
  const D = an(S, u), [J, ae] = c.useState(D);
  c.useEffect(() => {
    G.current && G.current.forceUpdate();
  }), ht(() => {
    if (!a || !b)
      return;
    const se = (re) => {
      ae(re.placement);
    };
    Lt(a);
    let Y = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: re
      }) => {
        se(re);
      }
    }];
    d != null && (Y = Y.concat(d)), y && y.modifiers != null && (Y = Y.concat(y.modifiers));
    const ne = bo(Lt(a), L.current, bt({
      placement: D
    }, y, {
      modifiers: Y
    }));
    return F.current(ne), () => {
      ne.destroy(), F.current(null);
    };
  }, [a, s, d, b, y, D]);
  const z = {
    placement: J
  };
  return B !== null && (z.TransitionProps = B), /* @__PURE__ */ x.jsx("div", bt({
    ref: U,
    role: "tooltip"
  }, A, {
    children: typeof p == "function" ? p(z) : p
  }));
}), pn = /* @__PURE__ */ c.forwardRef(function(n, r) {
  const {
    anchorEl: a,
    children: p,
    container: u,
    direction: s = "ltr",
    disablePortal: d = !1,
    keepMounted: b = !1,
    modifiers: S,
    open: y,
    placement: w = "bottom",
    popperOptions: B = ln,
    popperRef: A,
    style: L,
    transition: U = !1
  } = n, G = Zt(n, rn), [j, F] = c.useState(!0), D = () => {
    F(!1);
  }, J = () => {
    F(!0);
  };
  if (!b && !y && (!U || j))
    return null;
  const ae = u || (a ? go(Lt(a)).body : void 0);
  return /* @__PURE__ */ x.jsx(on, {
    disablePortal: d,
    container: ae,
    children: /* @__PURE__ */ x.jsx(sn, bt({
      anchorEl: a,
      direction: s,
      disablePortal: d,
      modifiers: S,
      ref: r,
      open: U ? !j : y,
      placement: w,
      popperOptions: B,
      popperRef: A
    }, G, {
      style: bt({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: !y && b && (!U || j) ? "none" : null
      }, L),
      TransitionProps: U ? {
        in: y,
        onEnter: D,
        onExited: J
      } : null,
      children: p
    }))
  });
}), Kt = 1.5, cn = Xt()((e) => {
  const {
    borderRadiuses: n,
    constructs: { border: r, surface: a },
    mixins: { boxShadow: p },
    palette: u,
    spacing: s,
    typography: d
  } = e;
  return {
    root: {
      "& .MuiPaper-root": {
        background: a.neutral.forcedWhite,
        border: `1px solid ${r.neutral.weak}`,
        borderRadius: n[200],
        boxShadow: p("700", a.neutral.xxStrong),
        "&:empty": {
          display: "none"
        }
      },
      "& .MuiAutocomplete-listbox": {
        padding: s(Kt, 0),
        "&:has(.MuiListSubheader-root) > li:not(:first-child)": {
          borderTop: `1px solid ${a.neutral.weak}`,
          marginTop: s(1.5)
        }
      },
      "& .MuiAutocomplete-option": {
        minHeight: s(5.25),
        padding: s(1.25, 2),
        "&:hover, &.Mui-focused": {
          backgroundColor: a.neutral.xWeak
        }
      },
      "& .MuiListSubheader-root": {
        ...d.xsmall,
        background: a.neutral.forcedWhite,
        color: u.gray[800],
        fontWeight: 600,
        padding: s(1.5, 2),
        top: s(-Kt)
      }
    }
  };
}), qt = (e) => {
  const { className: n, modifiers: r, style: a, ...p } = e, { spacing: u } = po(), { classes: s, cx: d } = cn(), b = fo(p.open);
  return We.ifFeature(
    "encore",
    /* @__PURE__ */ x.jsx(
      pn,
      {
        className: d(s.root, n),
        modifiers: [
          // add gap between popper and reference (anchor)
          {
            name: "offset",
            options: {
              // [parallel (skid), perpendicular (distance)]
              offset: [0, parseInt(u(1), 10)]
            }
          },
          ...r || []
        ],
        placement: "bottom-start",
        style: { zIndex: b, ...a },
        ...p
      }
    ),
    /* @__PURE__ */ x.jsx(
      At,
      {
        className: n,
        modifiers: r,
        placement: "bottom-start",
        ...p,
        style: { ...a, width: void 0 }
      }
    )
  );
};
function un(e, n) {
  const {
    className: r,
    classes: a = {},
    clearIcon: p,
    closeOnSelect: u = !0,
    getFilteredOptions: s,
    getTagsLimitLabel: d,
    hasClearButton: b = !1,
    hasPopupToggle: S = !1,
    inputValue: y,
    isAnyInputValueAllowed: w = !1,
    loading: B = !1,
    loadingText: A,
    noOptionsText: L,
    onChange: U,
    onClose: G,
    onHighlightChange: j,
    onInputChange: F,
    onOpen: D,
    open: J,
    popupIcon: ae,
    popupMinWidthFactor: z,
    renderOption: se,
    tagsLimit: Y,
    variant: ne,
    ...re
  } = e, [ee, P] = ft(y || ""), [fe, q] = ft(!1), [Ce, te] = ft("No matches for"), [ge, Le] = ft(!1), T = J === void 0 ? fe : J, tt = y === void 0 ? ee : y, Ie = no(() => T ? Jo() : 0, [T, ge]);
  ro(() => {
    T && Le(!0);
  }, []);
  const $e = {
    hasClearButton: b,
    hasPopupToggle: S,
    variant: ne,
    /* @startCleanup encore */
    hasRenderOption: !!se,
    popupMinWidthFactor: z,
    popperZIndex: Ie
    /* @endCleanup encore */
  }, { classes: Be } = Yo($e, { props: e }), K = ao(
    ({ style: l, ...H }) => /* @__PURE__ */ x.jsx(
      qt,
      {
        ...H,
        style: {
          minWidth: z && z !== 100 ? Qt[z] : l == null ? void 0 : l.width
        }
      }
    ),
    [z]
  ), k = en($e), ve = {
    ...a,
    groupLabel: ye(k.groupLabel, a.groupLabel),
    groupUl: ye(k.groupUl, a.groupUl),
    inputRoot: ye(k.inputRoot, a.inputRoot),
    listbox: ye(k.listbox, a.listbox),
    option: ye(k.option, a.option),
    paper: ye(k.paper, a.paper),
    popper: ye(k.popper, a.popper)
  }, Ae = z === 100 ? void 0 : qt, E = L || Ce;
  let W = B, Pe = A;
  return w && L && !W && (W = !0, Pe = L), /* @__PURE__ */ x.jsx(
    Zo,
    {
      ...re,
      classes: We.ifFeature("encore", Be, ve),
      className: We.ifFeature("encore", void 0, ye(k.root, r)),
      clearIcon: We.ifFeature("encore", /* @__PURE__ */ x.jsx(jt, { name: "circle-x-solid", size: 16 }), p),
      disableClearable: !b,
      disableCloseOnSelect: !u,
      filterOptions: s,
      forcePopupIcon: S,
      freeSolo: w,
      getLimitTagsText: d,
      inputValue: tt,
      limitTags: Y,
      loading: W,
      loadingText: Pe,
      noOptionsText: E,
      onChange: ot,
      onClose: Q,
      onHighlightChange: Me,
      onInputChange: Ge,
      onOpen: V,
      open: T,
      PopperComponent: We.ifFeature("encore", K, Ae),
      popupIcon: We.ifFeature(
        "encore",
        /* @__PURE__ */ x.jsx(jt, { name: "caret-down-solid", size: 16 }),
        ae || /* @__PURE__ */ x.jsx("div", { className: ye(k.defaultPopupIcon, ve.defaultPopupIcon), children: /* @__PURE__ */ x.jsx(Co, {}) })
      ),
      ref: n,
      renderOption: se
    }
  );
  function ot(l, H, C) {
    U(
      {
        value: H,
        reason: C
      },
      l
    );
  }
  function Q(l, H) {
    l.type !== "mousedown" && q(!1), G && G(
      {
        reason: H
      },
      l
    );
  }
  function Me(l, H, C) {
    j && j(
      {
        option: H,
        reason: C
      },
      l
    );
  }
  function Ge(l, H, C) {
    if (y === void 0 && (H = H.trimStart()), P(H), !L) {
      const Oe = window.jQuery ? $.__('No matches for "%1$s"', H) : `No matches for "${H}"`;
      te(Oe);
    }
    F && F(
      {
        value: H,
        reason: C
      },
      l
    );
  }
  function V(l) {
    l.type !== "mousedown" && q(!0), D && D(l);
  }
}
const qn = oo(un);
export {
  qn as A,
  Wn as D,
  _n as a,
  Gn as b,
  Bn as c,
  Kn as d
};
//# sourceMappingURL=autocomplete-n7dpskro.mjs.map
